import { Injectable, Injector } from "@angular/core";
import { BaseApi } from "@services/api/base.api";
import { Observable } from "rxjs";

@Injectable()
export class ListsApi extends BaseApi {
	constructor( injector: Injector ) { super(injector); }

	public register(data: any): Observable<any> {
		return this.post(this.url("/register"), data).pipe(this.defaultMap);
	}

	public view(hash:string): Observable<any> {
		return this.get(this.url("/view/:hash").params({hash})).pipe(this.defaultMap);
	}

	public recover(email:string, year?:number): Observable<any> {
		return this.post(this.url("/recover"), { email, year }).pipe(this.defaultMap);
	}

}
